import { cva, type VariantProps } from 'class-variance-authority'

export const buttonVariants = cva(
  "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold outline-none transition-colors duration-150 focus-visible:border-[var(--lms-color-focus-ring)] focus-visible:ring-[3px] focus-visible:ring-[var(--lms-color-focus-ring-soft)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-55 aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:opacity-55 data-[loading=true]:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: 'shadow-sm',
        primary: 'shadow-sm',
        secondary: 'shadow-sm',
        accent: 'shadow-sm',
        success: 'shadow-sm',
        destructive:
          'shadow-sm focus-visible:ring-[color-mix(in_srgb,var(--lms-color-danger)_28%,transparent)]',
        outline: 'border shadow-xs',
        ghost: '',
        link: 'h-auto rounded-none px-0 py-0 underline-offset-4',
      },
      size: {
        default: 'h-10 px-4 py-2 has-[>svg]:px-3',
        sm: "h-8 gap-1.5 px-3 text-sm has-[>svg]:px-2.5 [&_svg:not([class*='size-'])]:size-3.5",
        md: 'h-10 px-4 py-2 has-[>svg]:px-3',
        lg: 'h-11 px-6 text-base has-[>svg]:px-4',
        icon: 'size-10 p-0',
        'icon-sm': "size-8 p-0 [&_svg:not([class*='size-'])]:size-3.5",
        'icon-lg': 'size-11 p-0',
      },
      fullWidth: {
        true: 'w-full',
      },
      mobileFullWidth: {
        true: 'w-full sm:w-auto',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)

export type ButtonVariant = NonNullable<VariantProps<typeof buttonVariants>['variant']>
export type ButtonSize = NonNullable<VariantProps<typeof buttonVariants>['size']>

